export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/defaultImg.a09b5eaf.png";